<template>
  <div class="content">漆面保护膜</div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.content {
  height: calc(100vh - 60px);
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
